export const cleanIntrinsic = (intrinsic) => {
  // If already an array of numbers, return as is
  if (
    Array.isArray(intrinsic) &&
    intrinsic.every((v) => typeof v === "number")
  ) {
    return intrinsic;
  }

  // If array of strings/numbers, clean each value
  // Handle case where array contains comma-separated strings
  if (Array.isArray(intrinsic)) {
    const result = [];
    intrinsic.forEach((val) => {
      if (typeof val === "number") {
        result.push(val);
      } else {
        const str = String(val);
        // If the string contains commas, split it
        if (str.includes(",")) {
          const values = str.split(",").map((v) => {
            const cleaned = v.trim().replace(/f$/i, "");
            return Number(parseFloat(cleaned).toFixed(1)) || 0;
          });
          result.push(...values);
        } else {
          // Single value
          const cleaned = str.replace(/f$/i, "").trim();
          result.push(Number(parseFloat(cleaned).toFixed(1)) || 0);
        }
      }
    });
    return result;
  }

  // If string (comma-separated or single value), parse it
  if (typeof intrinsic === "string") {
    const values = intrinsic.split(",").map((v) => {
      const cleaned = v.trim().replace(/f$/i, "");
      return Number(parseFloat(cleaned).toFixed(1)) || 0;
    });
    return values;
  }
  return [];
};
